/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerDeleteMutationResponse,
  TelegramProductsUserControllerDeletePathParams,
  TelegramProductsUserControllerDelete401,
} from '../types/TelegramProductsUserControllerDelete.ts';

function getTelegramProductsUserDeleteUrl(id: TelegramProductsUserControllerDeletePathParams['id']) {
  const res = { method: 'DELETE', url: `/api/user/telegram/products/${id}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/:id}
 */
export async function telegramProductsUserDelete(
  id: TelegramProductsUserControllerDeletePathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerDeleteMutationResponse,
    ResponseErrorConfig<TelegramProductsUserControllerDelete401>,
    unknown
  >({ method: 'DELETE', url: getTelegramProductsUserDeleteUrl(id).url.toString(), ...requestConfig });
  return res.data;
}
